import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { UserRegistration, Registration } from '../model';
import { AO_AUTH_URL, SSO_TOKEN_NAME } from '~auth/providers/auth.provider';

// need to define these
type USER_REGISTRATION_RESPONSE = {};
type USER_VERIFICATION_RESPONSE = {};
type FORGOT_PASSWORD_RESPONSE = {};
type RESET_PASSWORD_RESPONSE = {};

@Injectable()
export abstract class RegistrationService {
  constructor(protected http: HttpClient, @Inject(AO_AUTH_URL) protected AO_URL: string, @Inject(SSO_TOKEN_NAME) protected tokenName: string) { }
  abstract registerUser(user: UserRegistration): Observable<any>;
  abstract verifyUser(registration: Registration): Observable<any>;
  abstract forgotPassword(username: string): Observable<any>;
  abstract resetPassword(requestId: string, password: string): Observable<any>;
  abstract resendValidationCode(username: string): Observable<any>;
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/services/registration.service.ts